import { enumUIModes } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function isInViewer() {
  return (
    Globals._uiConfig.GetUIMode() === enumUIModes.chart &&
    !Globals._uiConfig.InBackgroundEditorMode()
  );
}
